import * as React from "react";
const SvgPlus = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M11 11V4h2v7h7v2h-7v7h-2v-7H4v-2h7Z" fill="var(--icon-primary)" /></svg>;
export default SvgPlus;